import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["priceDisplay", "variant"]
  static values = {
    objectId: Number,
    objectType: String
  }

  connect() {
    this.updatePrice()
  }

  updatePrice() {
    const variantId = this.hasVariantTarget ? this.variantTarget.value : null

    if (!variantId) {
      this.priceDisplayTarget.innerHTML = '<p class="text-muted text-center">No variant selected</p>'
      return
    }

    fetch(`/crafting/${this.objectTypeValue}/${this.objectIdValue}/calculate_price?variant_id=${variantId}`, {
      headers: {
        'Accept': 'application/json'
      }
    })
    .then(response => response.json())
    .then(data => {
      this.priceDisplayTarget.innerHTML = data.html
    })
    .catch(error => {
      console.error('Error fetching price:', error)
    })
  }
}

